// Extra feature sections built from help center articles.
export const MORE_GROW = {
    "online-booking": {
        tabLinks: {
            "booking-page": "/help-center/knowledge-base/online-presence/how-clients-book-online#the-booking-journey",
            "direct-links": "/help-center/knowledge-base/online-presence/create-booking-links#link-types",
            "social-booking": "/help-center/knowledge-base/online-presence/set-up-social-and-google-booking",
            "checkout-confidence": "/help-center/knowledge-base/online-presence/how-clients-book-online#what-shapes-the-booking-site",
        },
        sections: [
            {
                type: "row",
                title: "Let clients pick their favorite",
                description: "Clients can choose the team member they love, or pick Any professional to see the most open times.",
                image: "online-presence/booking-site-professional",
                href: "/help-center/knowledge-base/online-presence/how-clients-book-online#the-booking-journey",
                linkLabel: "See the booking journey",
            },
            {
                type: "group",
                heading: "Get booked wherever clients find you",
                intro: "Put your booking site on posters, flyers and your own website in a few clicks.",
                cards: [
                    {
                        title: "Scan to book",
                        description: "Turn any booking link into a QR code and download it for your front desk, posters or flyers.",
                        image: "online-presence/link-builder-qr",
                        href: "/help-center/knowledge-base/online-presence/create-booking-links#create-a-link",
                        linkLabel: "Create a QR code",
                    },
                    {
                        title: "Book right on your website",
                        description: "Add a Book button to your own site so visitors book in a pop-up without ever leaving your page.",
                        image: "online-presence/website-widget-code",
                        href: "/help-center/knowledge-base/online-presence/add-a-book-button-to-your-website#add-the-widget",
                        linkLabel: "Add a Book button",
                    },
                ],
            },
            {
                type: "row",
                title: "Grow every booking with add-ons",
                description: "Offer extras like a deep conditioning mask when clients book online. Each add-on adds its own price and time automatically.",
                image: "services/online-addon-picker",
                href: "/help-center/knowledge-base/services/create-service-add-ons#add-ons-in-online-booking",
                linkLabel: "Set up add-ons",
            },
            {
                type: "row",
                title: "Secure the booking upfront",
                description: "Ask for a full payment or a deposit when clients book online. They pay by card or gift card, and it comes off the total at checkout.",
                image: "payments/online-deposit-payment",
                href: "/help-center/knowledge-base/payments/collect-deposits#online-bookings",
                linkLabel: "Collect deposits online",
            },
            {
                type: "group",
                heading: "Fill more chairs with less effort",
                cards: [
                    {
                        title: "Book the whole group at once",
                        description: "Clients can book for several guests at the same time, each with their own services and professional.",
                        image: "calendar/online-group-guests",
                        href: "/help-center/knowledge-base/calendar/how-clients-book-group-appointments-online#the-client-booking-steps",
                        linkLabel: "Take group bookings",
                    },
                    {
                        title: "Never lose a client to a full day",
                        description: "When no time suits them, clients can join your waitlist straight from the booking site.",
                        image: "online-presence/booking-site-time",
                        href: "/help-center/knowledge-base/calendar/manage-waitlist-settings#turn-on-the-online-waitlist",
                        linkLabel: "Turn on the waitlist",
                    },
                ],
            },
            {
                type: "row",
                title: "Turn happy visits into Google reviews",
                description: "Google rating boost adds your review link to the thank-you email, and prompts clients who rate you highly to share it on Google.",
                image: "online-presence/google-rating-boost",
                href: "/help-center/knowledge-base/online-presence/google-rating-boost#turn-on-google-rating-boost",
                linkLabel: "Boost my Google rating",
            },
            {
                type: "row",
                title: "Bookings on your terms",
                description: "Set how much notice you need, how far ahead clients can book and which bookings are approved automatically, for each location.",
                image: "calendar/location-booking-settings",
                href: "/help-center/knowledge-base/calendar/manage-online-booking-settings#booking-settings-explained",
                linkLabel: "Set my booking rules",
            },
        ],
    },
    memberships: {
        tabLinks: {
            "recurring-plans": "/help-center/knowledge-base/packages-and-gift-cards/create-packages#create-a-package",
            "package-balances": "/help-center/knowledge-base/clients/manage-client-wallets#open-a-client-wallet",
            "renewal-recovery": "/help-center/knowledge-base/reports/packages-activity-report#what-it-shows",
            "vip-retention": "/help-center/knowledge-base/clients/manage-client-rewards#add-a-reward",
        },
        sections: [
            {
                type: "row",
                title: "Bundle your best services",
                description: "Combine services and products into one package with a discounted price, and clients see exactly how much they save.",
                image: "gift-cards/package-edit",
                href: "/help-center/knowledge-base/packages-and-gift-cards/create-packages#create-a-package",
                linkLabel: "Build a package",
            },
            {
                type: "group",
                heading: "Sell packages your way",
                cards: [
                    {
                        title: "Sell at the front desk",
                        description: "Add a package to any quick sale from the Packages tab and take payment in seconds.",
                        image: "gift-cards/sell-package-select-items",
                        href: "/help-center/knowledge-base/packages-and-gift-cards/sell-packages#sell-a-package",
                        linkLabel: "Sell a package",
                    },
                    {
                        title: "Send it as an invoice",
                        description: "Add packages to an invoice and clients pay through a secure link by email or text.",
                        image: "sales/invoice-add-items",
                        href: "/help-center/knowledge-base/sales/create-and-send-invoices#create-an-invoice",
                        linkLabel: "Send an invoice",
                    },
                ],
            },
            {
                type: "row",
                title: "Perks your regulars will love",
                description: "Give clients an amount off, a percentage off, a free service or a free product as a thank-you or birthday treat.",
                image: "clients/reward-choose-type",
                href: "/help-center/knowledge-base/clients/manage-client-rewards#reward-types",
                linkLabel: "Choose a reward",
            },
            {
                type: "row",
                title: "Rewards that protect your margins",
                description: "Set a minimum purchase, decide if rewards combine with deals and let unused rewards expire after 1 to 12 months.",
                image: "clients/reward-redemption-limits",
                href: "/help-center/knowledge-base/clients/manage-client-rewards#redemption-limits",
                linkLabel: "Set reward limits",
            },
            {
                type: "group",
                heading: "Redeem perks right at checkout",
                intro: "Your team sees a client's rewards the moment they ring up the sale.",
                cards: [
                    {
                        title: "Rewards show up on their own",
                        description: "Checkout shows how many rewards the client has, so team members never forget to offer one.",
                        image: "sales/sale-rewards-available",
                        href: "/help-center/knowledge-base/sales/apply-rewards-at-checkout#apply-a-reward",
                        linkLabel: "Apply a reward",
                    },
                    {
                        title: "Totals worked out for you",
                        description: "The reward comes off before tax and the total updates instantly, so there's no math at the desk.",
                        image: "sales/sale-reward-applied",
                        href: "/help-center/knowledge-base/sales/apply-rewards-at-checkout#how-rewards-are-worked-out",
                        linkLabel: "See how rewards work",
                    },
                ],
            },
            {
                type: "row",
                title: "Know who your VIPs are",
                description: "The Most valuable clients report shows who spends the most with you, so you know who to reward first.",
                image: "reports/report-most-valuable-clients",
                href: "/help-center/knowledge-base/reports/most-valuable-clients-report",
                linkLabel: "Find my VIPs",
            },
            {
                type: "row",
                title: "A full history of every perk",
                description: "See when each reward was added, used, removed or expired, and which team member did it.",
                image: "clients/reward-activity",
                href: "/help-center/knowledge-base/clients/manage-client-rewards#rewards-activity",
                linkLabel: "View reward activity",
            },
        ],
    },
    "gift-cards": {
        tabLinks: {
            "sell-online": "/help-center/knowledge-base/packages-and-gift-cards/set-up-gift-cards#online-sales",
            "branded-delivery": "/help-center/knowledge-base/packages-and-gift-cards/manage-gift-cards#send-a-digital-gift-card",
            "easy-redemption": "/help-center/knowledge-base/packages-and-gift-cards/redeem-gift-cards#redeem-at-checkout",
        },
        sections: [
            {
                type: "row",
                title: "Designs that match your brand",
                description: "Pick a ready-made design for your gift card page and emails, or upload your own artwork.",
                image: "gift-cards/gift-card-artwork",
                href: "/help-center/knowledge-base/packages-and-gift-cards/set-up-gift-cards#artwork",
                linkLabel: "Pick my artwork",
            },
            {
                type: "group",
                heading: "Sell gift cards at the front desk",
                cards: [
                    {
                        title: "Any amount, any time",
                        description: "Sell a custom amount or a running promotion, and Zobliss can create the card number for you.",
                        image: "gift-cards/gift-card-sell",
                        href: "/help-center/knowledge-base/packages-and-gift-cards/sell-gift-cards#sell-in-store",
                        linkLabel: "Sell a gift card",
                    },
                    {
                        title: "Add it to any checkout",
                        description: "Ring up gift cards on their own or alongside services and products, and credit the team member who sold it.",
                        image: "gift-cards/gift-card-in-sale",
                        href: "/help-center/knowledge-base/packages-and-gift-cards/sell-gift-cards#sell-in-store",
                        linkLabel: "Ring up a gift card",
                    },
                ],
            },
            {
                type: "row",
                title: "Holiday promotions that sell themselves",
                description: "Sell gift cards worth more than clients pay, with start and end dates so promotions run on their own.",
                image: "gift-cards/gift-card-promotion",
                href: "/help-center/knowledge-base/packages-and-gift-cards/create-gift-card-promotions#add-a-promotion",
                linkLabel: "Create a promotion",
            },
            {
                type: "row",
                title: "Every card in one place",
                description: "See every gift card you've sold or added, with its balance, purchaser and owner.",
                image: "gift-cards/gift-cards-list",
                href: "/help-center/knowledge-base/packages-and-gift-cards/manage-gift-cards",
                linkLabel: "Manage my gift cards",
            },
            {
                type: "group",
                heading: "Track every dollar",
                intro: "Know what's been spent and what you still owe at a glance.",
                cards: [
                    {
                        title: "The full story of each card",
                        description: "Open any card to see its balance, original amount and every sale, redemption and refund.",
                        image: "gift-cards/gift-card-details",
                        href: "/help-center/knowledge-base/packages-and-gift-cards/manage-gift-cards#view-a-gift-card",
                        linkLabel: "View card activity",
                    },
                    {
                        title: "Outstanding balances, totaled",
                        description: "The Gift card balances report adds up what's left on every card, so you always know your liability.",
                        image: "reports/report-gift-card-balances",
                        href: "/help-center/knowledge-base/reports/gift-card-balances-report",
                        linkLabel: "Check my balances",
                    },
                ],
            },
            {
                type: "row",
                title: "Bring your old gift cards with you",
                description: "Add gift cards sold before you used Zobliss with their number and balance, so clients can keep using them.",
                image: "gift-cards/gift-card-add",
                href: "/help-center/knowledge-base/packages-and-gift-cards/manage-gift-cards#add-an-existing-gift-card",
                linkLabel: "Add existing cards",
            },
            {
                type: "row",
                title: "Pay deposits with a gift card",
                description: "When a service needs a deposit, clients can enter a gift card code while booking online to pay some or all of it.",
                image: "payments/online-deposit-payment",
                href: "/help-center/knowledge-base/packages-and-gift-cards/redeem-gift-cards#redeem-online",
                linkLabel: "Redeem online",
            },
        ],
    },
    "inventory-retail-management": {
        tabLinks: {
            "stock-visibility": "/help-center/knowledge-base/inventory/track-stock-levels#view-stock",
            "retail-checkout": "/help-center/knowledge-base/inventory/sell-products#sell-a-product",
            "reorder-timing": "/help-center/knowledge-base/inventory/track-stock-levels#how-stock-changes",
            "product-insights": "/help-center/knowledge-base/reports/retail-sales-report",
        },
        sections: [
            {
                type: "row",
                title: "Stock counts for every location",
                description: "Switch to table view to see how many of each product are left at every location, updated as you sell.",
                image: "inventory/inventory-table",
                href: "/help-center/knowledge-base/inventory/track-stock-levels#view-stock",
                linkLabel: "Check my stock",
            },
            {
                type: "group",
                heading: "Get your shelves set up fast",
                cards: [
                    {
                        title: "Import your whole product list",
                        description: "Moving from another system? Upload a CSV instead of adding products one by one.",
                        image: "inventory/inventory-import",
                        href: "/help-center/knowledge-base/inventory/import-products#import-from-csv",
                        linkLabel: "Import my products",
                    },
                    {
                        title: "Keep prices up to date",
                        description: "Update a product's price, cost or details whenever they change, in one simple panel.",
                        image: "inventory/product-edit",
                        href: "/help-center/knowledge-base/inventory/update-and-delete-products#edit-a-product",
                        linkLabel: "Update a product",
                    },
                ],
            },
            {
                type: "row",
                title: "See which products make you money",
                description: "The Inventory report shows units sold, gross sales and profit for each product, based on your cost.",
                image: "reports/report-inventory",
                href: "/help-center/knowledge-base/reports/inventory-report#columns",
                linkLabel: "See product profit",
            },
            {
                type: "row",
                title: "Reward team members who sell retail",
                description: "Set a default product commission, or a different rate for specific products, so your team is paid for every sale.",
                image: "team/commission-rule",
                href: "/help-center/knowledge-base/team/set-up-commissions#set-default-rules",
                linkLabel: "Set product commission",
            },
            {
                type: "group",
                heading: "Retail that fits every sale",
                cards: [
                    {
                        title: "Product-only quick sales",
                        description: "Ring up a retail purchase in seconds, with or without a client on the sale.",
                        image: "sales/sale-select-items",
                        href: "/help-center/knowledge-base/sales/create-a-quick-sale#start-a-quick-sale",
                        linkLabel: "Start a quick sale",
                    },
                    {
                        title: "Sell products remotely",
                        description: "Add products to an invoice and send a payment link. Stock goes down when the client pays.",
                        image: "sales/invoice-create",
                        href: "/help-center/knowledge-base/sales/create-and-send-invoices#create-an-invoice",
                        linkLabel: "Invoice a product",
                    },
                ],
            },
            {
                type: "row",
                title: "The right tax on every product",
                description: "Set a retail sales tax for products separately from services, for each location you run.",
                image: "sales/tip-tax-settings",
                href: "/help-center/knowledge-base/sales/set-up-taxes#set-tax-rates",
                linkLabel: "Set retail tax",
            },
        ],
    },
    "pos-kiosk": {
        tabLinks: {
            "kiosk-mode": "/help-center/knowledge-base/sales/create-a-quick-sale#start-a-quick-sale",
            "fast-checkout": "/help-center/knowledge-base/sales/create-a-quick-sale#change-an-item",
            "in-person-payments": "/help-center/knowledge-base/sales/take-payments-at-checkout#take-a-payment",
        },
        sections: [
            {
                type: "row",
                title: "Tap, insert or swipe on Square Terminal",
                description: "Send the checkout amount straight to your paired Square Terminal, where the client pays by card.",
                image: "payments/square-terminal-waiting",
                href: "/help-center/knowledge-base/payments/take-square-terminal-payments#charge-on-the-terminal",
                linkLabel: "Take terminal payments",
            },
            {
                type: "group",
                heading: "Every way your clients pay",
                cards: [
                    {
                        title: "Card, cash or gift card",
                        description: "Charge a new card, a saved card or Square Terminal, and take cash or gift cards too.",
                        image: "/images/features/pos-kiosk/kiosk-card.webp",
                        href: "/help-center/knowledge-base/payments/take-card-payments#card-options",
                        linkLabel: "See card options",
                    },
                    {
                        title: "Charge a card on file",
                        description: "Regulars don't need to hand over a card. Pick their saved Stripe or Square card and you're done.",
                        image: "payments/select-saved-card",
                        href: "/help-center/knowledge-base/payments/take-card-payments#charge-a-saved-card",
                        linkLabel: "Charge a saved card",
                    },
                ],
            },
            {
                type: "row",
                title: "Tips split fairly, every time",
                description: "Offer quick tip percentages at checkout and split one tip between several team members on the same sale.",
                image: "sales/sale-tip-split",
                href: "/help-center/knowledge-base/sales/set-up-and-manage-tips#split-a-tip",
                linkLabel: "Set up tips",
            },
            {
                type: "row",
                title: "Discounts in two clicks",
                description: "Take a fixed amount or a percentage off the whole sale, and the total updates straight away.",
                image: "sales/sale-cart-discount",
                href: "/help-center/knowledge-base/sales/apply-discounts-at-checkout#apply-a-cart-discount",
                linkLabel: "Apply a discount",
            },
            {
                type: "group",
                heading: "Loyalty and gift cards at the register",
                cards: [
                    {
                        title: "Apply rewards before they pay",
                        description: "Tick a reward from the client's wallet and see the new total before you take payment.",
                        image: "sales/sale-apply-reward",
                        href: "/help-center/knowledge-base/sales/apply-rewards-at-checkout#apply-a-reward",
                        linkLabel: "Apply a reward",
                    },
                    {
                        title: "Split with a gift card",
                        description: "Apply a gift card balance, then pay any remaining amount with another payment method.",
                        image: "gift-cards/gift-card-redeem",
                        href: "/help-center/knowledge-base/sales/take-payments-at-checkout#split-a-payment-with-a-gift-card",
                        linkLabel: "Split a payment",
                    },
                ],
            },
            {
                type: "row",
                title: "Receipts printed or emailed",
                description: "Print a receipt at the desk or email it to the client, or send receipts automatically after every payment.",
                image: "sales/sale-payment-details",
                href: "/help-center/knowledge-base/sales/share-and-print-receipts#send-a-receipt",
                linkLabel: "Send a receipt",
            },
            {
                type: "row",
                title: "Keep a shared device locked down",
                description: "Set a front desk PIN so team members can't open payouts or reports from the calendar without it.",
                image: "team/front-desk-pin",
                href: "/help-center/knowledge-base/team/set-a-front-desk-pin#set-the-pin",
                linkLabel: "Set a front desk PIN",
            },
        ],
    },
};
